import { motion } from "framer-motion";
import WaitlistForm from "@/components/WaitlistForm";
import { Link } from "react-router-dom";

export default function FinalCTASection() {
  return (
    <section
      id="waitlist"
      data-testid="final-cta-section"
      className="py-24 px-6 relative overflow-hidden"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      {/* Subtle background glow */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] pointer-events-none"
        style={{
          background: "radial-gradient(ellipse at center, rgba(255,255,255,0.03) 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-2xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-tight mb-4"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Stop babysitting your coding agents.
          </h2>
          <p className="text-base mb-10" style={{ color: "#A1A1AA" }}>
            Get early access to Runzr and take control of your AI coding
            sessions from anywhere.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex justify-center"
        >
          <WaitlistForm />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-6"
        >
          <Link
            to="/demo"
            data-testid="final-demo-link"
            className="text-sm no-underline transition-colors duration-200"
            style={{ color: "#71717A" }}
            onMouseEnter={(e) => (e.target.style.color = "#fff")}
            onMouseLeave={(e) => (e.target.style.color = "#71717A")}
          >
            or try the interactive demo first →
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
